import { render, staticRenderFns } from "./IcoSuperpath.vue?vue&type=template&id=98f4a7c8"
import script from "./IcoSuperpath.vue?vue&type=script&lang=js"
export * from "./IcoSuperpath.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports